/** PRB review workflow state for hub reviews (serialized as these exact strings). */
export enum IHubReviewStatus {
  InReview = "review",
  Approved = "approved",
  Rejected = "rejected",
}
